import React, { Component } from 'react'
import { connect } from 'react-redux'

import { closeModal } from '../../reducers/modal'

import NewsletterCollection from './NewsletterCollection'

class NewsletterSignupModal extends Component {
  render () {
    return <NewsletterCollection autoFocus trackingContext='Menu' />
  }
}

export default connect(null, {
  closeModal
})(NewsletterSignupModal)



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/NewsletterSignupModal.js